import { type Palette, type PaletteColor } from '@mui/material'
import { type IconButtonOwnProps } from '@mui/material/IconButton'
import { hasOwnProperty } from '../../../helpers'

type IconButtonColor = IconButtonOwnProps['color'] | undefined
export type GetPaletteColor = (color: IconButtonColor) => PaletteColor | undefined

export const getIconButtonPalette = (palette: Palette, color: IconButtonColor): PaletteColor | undefined => {
  const eligibleColor = !!color && color !== 'inherit' ? color : undefined

  return eligibleColor && hasOwnProperty(palette, eligibleColor) ? (palette[eligibleColor] as PaletteColor) : undefined
}
